import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BillingInfoDisplay = ({
  ...props
}) => {
  const [billingInfo, setBillingInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBillingInfo = async () => {
      try {
        const response = await axios.get('/v1/subscriptions/billing-info');
        setBillingInfo(response.data.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    fetchBillingInfo();
  }, []);

  if (loading)
    return (
      <div style={{ textAlign: 'center', margin: '10px 0', color: '#555' }}>
        Loading billing information...
      </div>
    );
  if (error)
    return (
      <div style={{ color: 'red', textAlign: 'center', margin: '10px 0' }}>
        {error}
      </div>
    );

  if (!billingInfo) {
    return (
      <div
        style={{
          textAlign: 'center',
          color: '#777',
          margin: '10px 0',
          fontStyle: 'italic',
        }}
      >
        No billing information found.
      </div>
    );
  }

  const {
    firstName,
    lastName,
    address: { street1, street2, city, region, postalCode, country },
    paymentMethod: { cardType, lastFour, expMonth, expYear },
  } = billingInfo;

  return (
    <div
      style={{
        maxWidth: '450px',
        margin: '20px auto',
        padding: '20px',
        border: '1px solid #ddd',
        borderRadius: '10px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div style={{ marginBottom: '20px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '10px',
          }}
        >
          <h4 style={{ margin: 0, fontSize: '16px', color: '#333' }}>
            Primary Card Information
          </h4>
        </div>
        <div
          style={{
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#f9f9f9',
          }}
        >
          <div>
            <p
              style={{
                margin: 0,
                fontSize: '14px',
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              {cardType} ending in ****{lastFour}
            </p>
            <p style={{ margin: 0, fontSize: '12px', color: '#777' }}>
              Expiry {expMonth}/{expYear}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingInfoDisplay;
